/**
 * ERRORS-1 — browser-specific steps for re-granting microphone access (the catalogue's
 * `grant_microphone` action). Keyed off a user-agent string the caller supplies, so this
 * stays DOM-free and testable.
 */
export function browserFamily(userAgent) {
    const ua = userAgent.toLowerCase();
    // Order matters: Edge and Chrome both say "chrome"; Chrome and Safari both say "safari".
    if (ua.includes("edg/"))
        return "edge";
    if (ua.includes("firefox/"))
        return "firefox";
    if (ua.includes("chrome/") || ua.includes("crios/"))
        return "chrome";
    if (ua.includes("safari/"))
        return "safari";
    return "other";
}
const MIC_HELP = {
    chrome: [
        "Click the tune/lock icon at the left of the address bar.",
        "Turn Microphone on (or choose Allow).",
        "Reload the page and start recording again.",
    ],
    edge: [
        "Click the lock icon at the left of the address bar, then Permissions for this site.",
        "Set Microphone to Allow.",
        "Reload the page and start recording again.",
    ],
    firefox: [
        "Click the microphone-with-a-slash icon in the address bar.",
        "Remove the “Blocked” permission for this site.",
        "Reload the page, start recording, and choose Allow when asked.",
    ],
    safari: [
        "Open Safari → Settings for This Website (or Settings → Websites → Microphone).",
        "Set Microphone to Allow for this site.",
        "Reload the page and start recording again.",
    ],
    other: [
        "Open this site’s settings from the address bar.",
        "Allow microphone access.",
        "Reload the page and start recording again.",
    ],
};
/** Numbered steps to re-grant microphone access in the browser identified by `userAgent`.
 * Also mention the OS-level switch on macOS/Windows, which silently overrides the browser. */
export function microphoneHelpSteps(userAgent) {
    const steps = [...MIC_HELP[browserFamily(userAgent)]];
    const ua = userAgent.toLowerCase();
    if (ua.includes("mac os x") || ua.includes("macintosh")) {
        steps.push("Still blocked? Check System Settings → Privacy & Security → Microphone.");
    }
    else if (ua.includes("windows")) {
        steps.push("Still blocked? Check Windows Settings → Privacy & security → Microphone.");
    }
    return steps;
}
//# sourceMappingURL=browserHelp.js.map